module.exports = __webpack_public_path__ + "static/media/nine-ball-header-side.3d90baaa.png";